import React, {Component} from 'react';
import {NavLink} from 'react-router-dom';

import {Progress, Table, ButtonDropdown, DropdownItem, DropdownMenu,DropdownToggle} from 'reactstrap';

import axios from "axios/index";
import {serverPath, lastSchoolYear, rangListLimit} from "./common";

import '../css/ranglist.css';

class  RangList extends Component{
    /*
    * helper array
    * [{"avatar":"mi17291","cnt":"93"},{"avatar":"student","cnt":"87"},{"avatar":"mi17115","cnt":"86"},{"avatar":"mi17161","cnt":"80"},{"avatar":"mi17238","cnt":"74"},{"avatar":"mi17140","cnt":"68"},{"avatar":"mi17144","cnt":"64"},{"avatar":"mi17293","cnt":"59"},{"avatar":"mi17012","cnt":"56"},{"avatar":"mi17081","cnt":"49"}],
    * */
    constructor(props){
        super(props);
        this.state={
            data:[],
            topTen:[],
            problemCount: 0,
            schoolYears:[],
            user:null,
            timeDropdownOpen:false,
            courseDropdownOpen:false,

            courses:[],
            selectedCourseId:0,
            selectedTime:"Sve vreme",

            courseLabel:"Svi kursevi",
        };


        this.toggleTimeDropdown = this.toggleTimeDropdown.bind(this);
        this.toggleCourseDropdown = this.toggleCourseDropdown.bind(this);
        this.getSchoolYearScore= this.getSchoolYearScore.bind(this);
        this.getAllTimeScore= this.getAllTimeScore.bind(this);
    }

    componentDidMount(){
        this.setSchoolYears().then(()=>{
            this.getData();
        });
    }

    getAllTimeScore(courseId){
        var self=this;

        axios.get(serverPath + "rangListService.php", {
            params:{
                action:'getAllTime',
                courseId: courseId,
            }
        }).then(function (response) {
            self.setState({
                data:response.data.rangList,
                topTen:response.data.rangList.slice(0,rangListLimit),
                problemCount: response.data.problemCount
            });

        });
    }

    getSchoolYearScore(year, courseId) {
        var years = year.split("/");
        this.setState({
            selectedTime:year,
        });
        var self = this;
        axios.get(serverPath + "rangListService.php", {
            params: {
                action: "getSchoolYear",
                year1: years[0],
                year2: years[1],
                courseId:courseId,
            }
        }).then(function (response) {
            self.setState({
                data: response.data.rangList,
                topTen: response.data.rangList.slice(0, rangListLimit),
                problemCount: response.data.problemCount
            });
        });
    }

    getData(){
        var self = this;
        //this.getAllTimeScore(0);

        //get logged user
        axios.get(serverPath + "authService.php",{
            params: {
                action: 'whoIsLoggedIn'
            }
        }).then(function (response) {

            self.setState({
                user:response.data
            });
        });
        if(this.props.algorithmRangList !== undefined && this.props.algorithmRangList === false){
            //get all courses to diplay in dropdown
            axios.get(serverPath + "rangListService.php",{
                params: {
                    action: 'getAllCourses'
                }
            }).then(function (response) {
                self.setState({
                    courses:response.data
                });
            });
            let lastYear = this.state.schoolYears[0];
            this.getSchoolYearScore(lastYear, 0);
        }
        else{
            this.getAlgorithmRangList();
        }
    }

    getScore(timeConstraint, courseConstraint){
        if(timeConstraint === "Sve vreme"){
            this.getAllTimeScore(courseConstraint);
        }
        else{
            this.getSchoolYearScore(timeConstraint, courseConstraint);
        }


    }
    getAlgorithmRangList(){
        var self = this;
        axios.get(serverPath + "rangListService.php",{
            params: {
                action: 'getAlgorithmRangList'
            }
        }).then(function (response) {
            self.setState({
                data: response.data.rangList,
                topTen: response.data.rangList.slice(0, rangListLimit),
                problemCount: response.data.problemCount
            });
        });
    }
    //@brief creates an array of school years ("2017/2018" for example) from current year until 2017
    async setSchoolYears(){
        let currentYear = (new Date()).getFullYear();
        let currentMonth = (new Date()).getMonth() + 1;//+1 because months are numbered from 0, for some reason

        var tmp = currentYear;

        //if month >=10, means that another school year has started and it should be added to list
        //example, on 1.10.2018 starts 2018/2019 school year, so 2019 needs to be added
        if(currentMonth >= 10){
            tmp++;
        }
        let schoolYears=[];
        while(tmp !== lastSchoolYear){
            schoolYears.push(tmp-1 + "/" + tmp);
            tmp--;
        }

        return this.setState({
            schoolYears:schoolYears,
        });
    }

    toggleTimeDropdown(){
        this.setState({
            timeDropdownOpen:!this.state.timeDropdownOpen,
        });
    }

    toggleCourseDropdown(){
        this.setState({
            courseDropdownOpen:!this.state.courseDropdownOpen,
        });
    }

    //@brief: renders user's name from object user
    renderUserName(user){
            return (
                <NavLink className="nav-link default-link" to={'/user/' + user.avatar}>
                    <span className="fa fa-user-circle"></span> {user.avatar}
                </NavLink>
            );
    }

    /*
    * @brief: renders single user for showing in list
    * @params:
    *   user(object):user to render
    *   index(int):user's index in array, used for showing it's rank
    * */
    renderSingleStudent(user, index){
        var perc = parseInt(user.cnt*100/this.state.problemCount, 10);
        return(
            this.state.user !== null && (this.state.user.roleName==="student" ||
                    (this.state.user.roleName === "ostali" && this.props.algorithmRangList === true)
                    ) && this.state.user.username === user.avatar ?
                <tr key={index} style={{'background-color': '#d8f779'}}>
                    <td>{index}</td>
                    <td style={{'text-align': 'left'}}>{this.renderUserName(user)}</td>
                    <td>{user.cnt}</td>
                    {
                        this.state.selectedCourseId === 0 ?
                            null :
                        <td>
                            <Progress value={perc} color={perc === 100 ? 'success' : perc >= 50 ? 'warning' : 'info'}>
                            {perc}% </Progress>
                        </td>
                    }
                    </tr>
                    :
                <tr key={index}>
                    <td>{index}</td>
                    <td style={{'text-align': 'left'}}>{this.renderUserName(user)}</td>
                    <td>{user.cnt}</td>
                    {
                        this.state.selectedCourseId === 0 ?
                            null :
                            <td>
                                <Progress value={perc} color={perc === 100 ? 'success' : perc >= 50 ? 'warning' : 'info'}>
                                    {perc}% </Progress>
                            </td>
                    }
                </tr>

        );

    }

    //@brief: renders all students
    renderAllStudents(){
        var users = this.state.topTen.map((user, index)=>this.renderSingleStudent(user, index+1));
        return(
            <div>
                <Table size="sm" hover>
                    <thead>
                        <th>#</th>
                        <th style={{'text-align': 'center'}}>Student</th>
                        <th> <span className="fa fa-line-chart" title="Broj rešenih zadataka"></span></th>
                        {   this.state.selectedCourseId === 0 ? null :
                            <th><span className="fa fa-percent"
                                      title={"Procenat rešenih zadataka.\nNa izabranom kursu postoji ukupno "+ this.state.problemCount + " zadataka."}></span></th>
                        }
                    </thead>
                </Table>
                <div id="tableContainer">
                    <Table size="sm" hover bordered>
                        <tbody>
                            {users}
                        </tbody>
                    </Table>
                </div>
                {this.renderLoggedStudent()}
            </div>
        );
    }

    //@brief: renders logged user's information on bottom of the list
    renderLoggedStudent(){

        if(this.state.user === undefined || this.state.user === null){
            return <div/>
        }
        //render this for others only if it is algor rang list, else render it only for student
        if((this.state.user.roleName === "ostali" && this.props.algorithmRangList === true) ||
            this.state.user.roleName === "student")
        {
            var rez, index = -1, i=0;
            for(i=0; i<this.state.data.length; i++){
                if(this.state.data[i].avatar === this.state.user.username){
                    rez = this.state.data[i];
                    index = i;
                    break;
                }
            }

            if(index === -1){
                return <div>Jos uvek niste rangirani</div>
            }
            else if(index < rangListLimit)
            {
                return <div> </div>
            }
            else{
                var perc = parseInt(rez.cnt*100/this.state.problemCount, 10);

                return(
                    <React.Fragment>
                        <hr/>
                        <Table size="sm" bordered>
                            <tbody>
                            <tr key={index+1} style={{'background-color': '#d8f779'}}>
                                <td>{index+1}</td>
                                <td style={{'text-align': 'left'}}>{this.renderUserName(rez)}</td>
                                <td>{rez.cnt}</td>
                                <td><Progress value={perc} color={perc === 100 ? 'success' : perc >= 50 ? 'warning' : 'info'}>{perc}%</Progress></td>
                            </tr>
                            </tbody>
                        </Table>
                    </React.Fragment>

                );
            }
        }
        else{//nobody is logged in or it it not student
            return(
                <div></div>
            );
        }
    }

    //@brief: renders school years to be shown in dropdown
    renderSchoolYears(){
        var yrs = this.state.schoolYears.map((year, index)=>{
            return(
                <DropdownItem key = {index} onClick={()=>{this.handleClickedTime(year)}}>
                    Školska {year}
                </DropdownItem>
            );
        });

        return yrs;
    }

    //@brief: renders courses to be shown in dropdown
    renderCourses(){
        var courses=this.state.courses.map((course, index)=>{
            return(
                <DropdownItem key = {index} onClick={()=>{this.handleClickedCourse(course.idCourse)}}>
                    {course.name}
                </DropdownItem>
            );
        });

        return courses;
    }

    handleClickedCourse(courseId) {
        var label;
        if(courseId === 0){
            label="Svi kursevi";
        }
        else{
            label = this.state.courses.filter((course)=>course.idCourse===courseId)[0].name;
        }

        this.setState({
            selectedCourseId: courseId,
            courseLabel:label,
        });
        this.getScore(this.state.selectedTime, courseId);
    }

    handleClickedTime(time){
        this.setState({
            selectedTime:time,
        });
        this.getScore(time, this.state.selectedCourseId);
    }

    render() {
        if(this.props.algorithmRangList === undefined){
            return <div/>
        }
        return (
            <div id="rangListContainer">
                <div className={'container-fluid'}>
{ this.props.algorithmRangList !== true &&
                    <div className={'row mb-2'}>
                        <div className={'col-6 text-center mb-2'}>
                            <ButtonDropdown isOpen={this.state.timeDropdownOpen} toggle={this.toggleTimeDropdown}>
                                <DropdownToggle caret>
                                    {this.state.selectedTime}
                                </DropdownToggle>
                                <DropdownMenu>
                                    <DropdownItem onClick={()=>{this.handleClickedTime("Sve vreme")}}>Sve vreme</DropdownItem>
                                    {this.renderSchoolYears()}
                                </DropdownMenu>
                            </ButtonDropdown>
                        </div>
                        <div className={'col-6 text-center'}>
                            <ButtonDropdown isOpen={this.state.courseDropdownOpen} toggle={this.toggleCourseDropdown}>
                                <DropdownToggle caret
                                    className = {'dropdownButton'}>
                                    {this.state.courseLabel}
                                </DropdownToggle>
                                <DropdownMenu>
                                    <DropdownItem onClick={()=>{this.handleClickedCourse(0)}}
                                                   >Svi kursevi</DropdownItem>
                                    {this.renderCourses()}
                                </DropdownMenu>
                            </ButtonDropdown>
                        </div>
                    </div>
}
                </div>

                {this.renderAllStudents()}
            </div>
        );
    }

}
export default RangList;
